export default __webpack_public_path__ + "static/media/head_banner_desctop.7b7aa59b.webp";